import React from 'react';
import { List } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';

import Avatar from '@src/components/Avatar';
import { User } from '@src/types';

type Props = {
  item: User;
};

const Component: React.FC<Props> = ({ item }) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    // @ts-ignore
    () => navigation.push('Profile', { id: item.id }),
    [item.id, navigation]
  );

  return (
    <List.Item
      onPress={handlePress}
      title={item.name}
      description={item.username}
      left={(props) => <Avatar {...props} source={item.avatar} size={52} />}
    />
  );
};

Component.displayName = 'UserCard';

export default React.memo(Component);
